<template>
  <div v-if="isActive">
    <slot />
  </div>
</template>

<script setup>
import { inject, computed, useSlots } from 'vue'

const props = defineProps({
  name: { type: [String, Number], required: true },
  title: { type: String, default: null }
})

const { register, active } = inject('tabs')

const isActive = computed(() => active.value === props.name)

const titleSlot = useSlots().title

register({
  name: props.name,
  title: props.title,
  titleSlot
})
</script>
